import { graphConfig, loginRequest } from "../../config/msal";
import jwt_decode from "jwt-decode";
import { msalInstance } from "../../index";

export async function getAccessToken() {

    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });
    
    return response;
}

export async function callMeGraph() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));//TODO: ver que hacer con el catch
}

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */
export async function callMsGraph(accessToken: string) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    headers.append("Authorization", bearer);
    const decoded: any = jwt_decode(accessToken);
    const sub: string = decoded.sub;
    const jwt = `${bearer.split(' ')[1]}.${btoa(JSON.stringify({ typ: 'JWT', alg: 'none' }))}.${sub}`;
    headers.append('X-JWT-Assertion', jwt);
    const options = {
        method: "GET",
        headers: headers
    };

    return await fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));//TODO: ver que hacer con el catch
}
